import script from "./Activation.vue?vue&type=script&setup=true&lang=js"
export * from "./Activation.vue?vue&type=script&setup=true&lang=js"

import "./Activation.vue?vue&type=style&index=0&id=4563044e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4563044e"]])

export default __exports__